<template>
  <a-spin :delay="300" :spinning="spinning">
    <div class="item">
      <a-icon class="icon" :type="icon" />
      <template v-if="!showEdit">
        <span>{{ label }}：{{ text || noText }}</span>
        <a ><a-icon class="edit m-" @click="handleEdit" title="编辑" v-if="edit" type="edit"></a-icon></a>
      </template>
      <template v-else>

        <span>{{ label }}：</span>
        <a-input
          v-if="component === 'input'"
          class="input"
          size="small"
          @blur="handleInputSave"
          :placeholder="label"
          v-bind="options"
          :style="{width:'120px'}"
          v-model="valueInfo" />
        <a-select @change="handleSelectSave" size="small" v-else-if="component === 'select'" v-model="valueInfo">
          <a-select-option :key="item.id" v-for="item in options.options" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </template>
    </div>
  </a-spin>
</template>

<script>

const props = {
  /**
   * label
   */
  label: {
    type: String,
    required: true
  },
  /**
   * 图标
   */
  icon: {
    type: String,
    required: true
  },
  /**
   * 无内容
   */
  noText: {
    type: String,
    default: '无'
  },
  /**
   * value
   */
  value: {
    type: [String, Number],
    required: true
  },
  /**
   * 更改key
   */
  changeKey: {
    type: String
  },
  /**
   * 是否可编辑
   */
  edit: {
    type: Boolean,
    default: false
  },
  /**
   * 组件类型
   */
  component: {
    type: String,
    default: 'input'
  },
  /**
   * 组件 props
   */
  options: {
    type: Object
  },
  /**
   * 保存方法
   */
  save: {
    type: Function
  }
}

export default {
  name: 'UserInfoItem',
  props,
  data: () => ({
    showEdit: false,
    valueInfo: '',
    spinning: false
  }),
  computed: {
    text() {
      if (this.component === 'input') {
        return this.value
      } else if (this.component === 'select') {
        return this.options.options.find(v => v.id === this.value)?.name
      } else {
        return ''
      }
    }
  },
  methods: {
    handleInputSave({ target }) {
      const { value } = target
      this.spinning = true
      this.save({
        key: this.changeKey,
        value
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          setTimeout(() => {
            this.$parent.$parent.getData()
          }, 500)
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.showEdit = false
        this.spinning = false
      })
    },
    handleSelectSave(value) {
      this.spinning = true
      this.save({
        key: this.changeKey,
        value
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          setTimeout(() => {
            this.$parent.$parent.getData()
          }, 500)
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.showEdit = false
        this.spinning = false
      })
    },
    handleEdit() {
      this.showEdit = !this.showEdit
      this.valueInfo = this.value
    }
  }
}
</script>

<style scoped lang='less'>
.item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  .icon {
    margin-right: 7px;
  }
  .edit{
    margin-left: 5px;
    cursor: pointer;
  }
  .input{
    margin-left: 5px;
  }
}

</style>
